module.exports = __webpack_public_path__ + "static/globe-178e2e3f517dcceb7efe583c1a0d7bae.png";